import { FocusNode } from '@please/lrud'
import styled from 'styled-components'

export const CalendarElem = styled(FocusNode)`
  display: flex;
  flex-direction: row;
  padding-right: 72px;
  align-items: center;
`
export const CalendarDay = styled(FocusNode)`
  display: flex;
  align-items: stretch;
  cursor: pointer;
  background: ${({ theme }) => theme.colors.calendar.background};
  line-height: 1em;
  color: ${({ theme }) => theme.colors.text};
  text-transform: uppercase;
  border-radius: 8px;
  overflow: hidden;
  margin: 0 16px 0 0;
  font-size: 24px;
  font-weight: 700;
  height: 60px;
  box-shadow: ${({ theme }) => theme.colors.calendar.border} 0 0 0 2px inset;

  &.isActiveFilter {
    background-color: ${({ theme }) =>
      theme.colors.calendar.activeElem.background};
    box-shadow: ${({ theme }) => theme.colors.calendar.activeElem.border} 0 0 0
      2px inset;
    color: ${({ theme }) => theme.colors.primary};
  }

  &.isFocusedLeaf {
    box-shadow: inset 0 0 0 2px
      ${({ theme }) => theme.colors.calendar.focusedElem.border};
    background: ${({ theme }) => theme.colors.calendar.focusedElem.background};
    color: ${({ theme }) => theme.colors.primary};
  }
`

export const Label = styled.div`
  display: flex;
  flex: 1 1;
  align-items: center;
  min-width: 144px;
  height: 60px;
  padding: 0 14px;
  justify-content: center;
`
